<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <d-row
      no-gutters
      class="page-header pt-4">
      <d-col
        col
        sm="6"
        class="text-center text-sm-left mb-0 mb-sm-0">
        <span class="text-uppercase page-subtitle">Zamówienia</span>
        <h3 class="page-title">
          Lista zamówień
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="light"
          class="text-nowrap-dashboard"
          @click.prevent="getCurrentDate">
          <i class="material-icons">double_arrow</i>
          Wróć do dzisiejszej daty
        </d-button>
        <d-button
          class="ml-3 text-nowrap"
          theme="success"
          @click.prevent="$router.push('/zamowienia/nowy')">
          <i class="material-icons">add</i>
          Dodaj zamówienie
        </d-button>
      </d-col>
    </d-row>
    <div
      no-gutters
      class="page-header pt-4 pb-3 d-flex flex-wrap">
      <div class="text-center order__date_top text-sm-left mb-1 pb-3">
        <d-button
          class="order__date_top_button"
          theme="light"
          @click.prevent="dateDown">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">
            keyboard_arrow_left
          </i>
        </d-button>
        <p class="order__date_top_text">
          <span class="text">
            {{ current_date.date + ' ' + month[current_date.month - 1] + ' ' + current_date.year }}
          </span>
          <d-badge
            size="sm"
            :theme="dayNames[0].name === currentDay ? 'success' : 'primary'"
            pill>
            {{ currentDayName }}
          </d-badge>
        </p>
        <d-button
          class="order__date_top_button"
          theme="light"
          @click.prevent="dateUp">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">keyboard_arrow_right</i>
        </d-button>
        <d-button
          class="order__date_top_date"
          outline
          theme="info"
          @click.prevent="openCalendar">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">calendar_today</i>
        </d-button>
        <d-badge
          v-if="orders.data"
          v-d-tooltip="'WYSŁANE / DO WYSŁANIA'"
          class="order__date_top_badge"
          :theme="count !== orders.data.length ? 'danger' : 'success'">
          <span v-if="orders.data">
            {{ count }} / {{ countNone }}</span>
        </d-badge>
      </div>
      <div class="d-flex flex-nowrap ml-auto mt-2">
        <d-button
          class="order__date_top_transport ml-4"
          :theme="current_view === 'planRoute' ? 'secondary' : 'dark'"
          @click.prevent="toggleView('planRoute')">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">{{ current_view === 'planRoute' ? 'close' : 'directions_car' }}</i>
          {{ current_view === 'planRoute' ? 'Zamknij trasy' : 'Planuj trasę' }}
        </d-button>
        <d-button
          class="order__date_top_transport ml-3"
          theme="primary"
          :class="{isLoading: route_downloading}"
          @click.prevent="exportRouteFileExcel">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">download</i>
          Pobierz trasę
        </d-button>
        <d-button
          :theme="current_view === 'duplicateRoute' ? 'secondary' : 'info'"
          class="order__date_top_transport ml-3"
          @click.prevent="toggleView('duplicateRoute')">
          <i
            class="material-icons"
            style="margin-left: 0.2rem">{{ current_view === 'duplicateRoute' ? 'close' : 'multiple_stop' }}</i>
          Kopiuj trasę
        </d-button>
      </div>
    </div>
    <div class="d-flex justify-content-end align-items-bottom mb-3">
      <d-button
        v-if="conditions.is_completed_weighting && !button_disabled_pdf"
        theme="success"
        class="ml-2 my-2"
        style="min-width: 6rem;"
        :disabled="download !== false"
        @click.prevent="exportFilePDF">
        <i class="material-icons">download</i>
        PDF
      </d-button>
      <d-button
        theme="primary"
        :class="{
          'ml-3 my-2': true,
          'isLoading': isMergeInProgress
        }"
        outline
        :disabled="!isOrdersMergeEnabled || isMergeInProgress"
        @click="submitOrdersMerge">
        <i
          class="material-icons"
          style="transform: rotate(360deg);">join_full</i>
        Połącz wybrane
      </d-button>
      <d-button
        v-if="!button_disabled_pdf"
        theme="warning"
        class="ml-3 my-2"
        style="min-width: 6rem;"
        :disabled="download !== false || !isBulkPaymentEnabled"
        @click="submitBulkPayments">
        <i
          class="material-icons"
          style="transform: rotate(360deg);">euro_symbol</i>
        Opłać
      </d-button>
    </div>
    <d-row
      v-if="current_view === 'main'"
      class="d-flex ml-0 mb-3 page-filters w-100">
      <validation-observer
        ref="orders-filters-form"
        tag="form"
        style="width: 100%;"
        class="d-flex">
        <d-input
          v-model="filters.search"
          placeholder="Szukaj odbiorcy" />
        <v-select
          v-model="filters.supplier_id"
          class="ml-2 w-100"
          :options="suppliers"
          :reduce="supplier => supplier.id"
          placeholder="Wybierz dostawcę"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <v-select
          v-model="filters.weighting_status"
          class="ml-2 w-100"
          :options="isWeightValues"
          :reduce="weight => weight.value"
          placeholder="Zważone"
          :searchable="false"
          label="name">
          <template
            slot="option"
            slot-scope="option">
            <div class="d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
          <template
            slot="selected-option"
            slot-scope="option">
            <div class="selected d-center">
              {{ option.name ? option.name : '' }}
            </div>
          </template>
        </v-select>
        <d-button
          theme="info"
          outline
          class="text-nowrap ml-2"
          @click.prevent="validateFiltersForm">
          Szukaj
        </d-button>
        <d-button
          theme="danger"
          outline
          class="text-nowrap ml-2"
          @click.prevent="clearFilters">
          Resetuj filtry
        </d-button>
      </validation-observer>
    </d-row>
    <d-card
      style="width: 100%;"
      class="mb-3">
      <order-form-calendar
        :current-month="currentMonthDays"
        :date="current_date"
        :date-name="dayNames"
        :first-month-day="firstMonthDay"
        :month="month"
        :prev-month="prevMonthDays"
        :prev-month-days="prevMonth"
        :weekday-name="week_day_names"
        :weekdays="week_days"
        :close-modal="closeCalendar"
        :show-modal="show_calendar" />
      <table
        v-if="current_view === 'main'"
        class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0 align-middle text-center"
              style="width: 55px">
              <d-checkbox
                v-model="ids_all"
                inline
                class="my-auto mx-auto"
                :disabled="isMergeInProgress" />
            </th>
            <th
              v-if="isSupplierFilterSaved"
              scope="col"
              :class="{
                'sorting-trigger align-middle border-0 text-center column-sortable': true,
                'is-active': sorting.column && sorting.column === 'ordering',
                'is-up': sorting.direction && sorting.column === 'ordering' && sorting.direction === 'ASC',
                'is-disabled': !loaded
              }"
              style="width: 40px"
              @click.prevent="sortBy('ordering')">
              Kolejność na trasie
            </th>
            <th
              v-else
              scope="col"
              :class="{
                'sorting-trigger border-0 align-middle text-center column-sortable pl-0': true,
                'is-active': sorting.column && sorting.column === 'id',
                'is-up': sorting.direction && sorting.column === 'id' && sorting.direction === 'ASC',
                'is-disabled': !loaded
              }"
              style="width: 40px"
              @click.prevent="sortBy('id')">
              ID
            </th>
            <th
              scope="col"
              class="border-0 align-middle text-center">
              WZ
            </th>
            <th
              scope="col"
              class="border-0 align-middle">
              Odbiorca
            </th>
            <th
              scope="col"
              class="border-0 align-middle">
              Kwota
            </th>
            <th
              scope="col"
              class="border-0 align-middle">
              Kierowca
            </th>
            <th
              scope="col"
              class="border-0 align-middle text-right">
              Produkty
            </th>
            <th
              scope="col"
              class="border-0 align-middle text-center"
              width="195">
              Akcje
            </th>
          </tr>
        </thead>
        <tbody v-if="allDataLoaded && orders && !load_error">
          <tr
            v-for="(order, index) of orders.data"
            :key="'user-' + index">
            <td class="align-middle text-center">
              <d-checkbox
                v-model="ids"
                class="my-auto mx-auto"
                inline
                :value="order.id"
                :disabled="isMergeInProgress" />
            </td>
            <td class="align-middle text-center">
              {{ isSupplierFilterSaved ? order.ordering + 1 : '' }}
            </td>
            <td class="align-middle text-center">
              {{ getWZNumber(order.order_number) }}
            </td>
            <td class="align-middle">
              {{ order.customer_name }}
              <span class="bottom-text">
                <span
                  v-if="order.shop_address && order.shop_post_code && order.shop_city"
                  class="bottom-text-value">
                  <span class="text-secondary">Adres: </span>
                  <span class="text-success">{{ order.shop_post_code + ' ' + order.shop_city }}</span><br>
                  <span class="text-secondary">Ulica: </span>
                  <span class="text-success">{{ order.shop_address }}</span>
                </span>
              </span>
            </td>
            <td class="align-middle">
              <span :class="getOrderPriceClass(order)">
                {{ (order.payment_transferred + order.payment_cash + order.payment_card).toFixed(2) }} / {{ order.price.toFixed(2) }} zł
              </span>
            </td>
            <td class="align-middle">
              <d-button
                :theme="order.supplier_name ? 'success' : 'danger'"
                outline
                style="min-width: 8rem"
                class="mr-2"
                :title="order.supplier_name ? 'Zmień dostawcę' : 'Dodaj dostawce'"
                :disabled="downloading === order.id"
                @click.prevent="getSingleOrder(order.id)">
                <template v-if="downloading !== order.id">
                  <i
                    class="material-icons"
                    style="font-size: 1.2rem">{{ order.supplier_name ? 'person_search' : 'person' }}</i>
                  {{ order.supplier_name ? order.supplier_name : 'Brak dostawcy' }}
                </template>
                <template v-else>
                  <div
                    class="spinner-border spinner-border-sm"
                    role="status" />
                </template>
              </d-button>
            </td>
            <td
              :class="{
                'align-middle text-right': true,
                orangeBg: order.customer_products_count !== order.order_products.length && order.added_by_customer == 1

              }">
              {{ order.order_products.length }}
            </td>
            <td class="align-middle text-center">
              <div
                class="d-flex flex-wrap justify-content-end"
                style="gap: 8px;">
                <d-button
                  v-if="!order.is_completed_weighting"
                  theme="light"
                  :class="{ 'partiallyWeightedBg' : isPartiallyWeighted(order)}"
                  class="action-button"
                  title="Ważenie"
                  @click.prevent="openWeighingModule(order.id, order.supplier_id, order)">
                  <i
                    class="material-icons"
                    style="transform: rotate(360deg); margin-left: 0.2rem">keyboard_capslock</i>
                </d-button>
                <d-button
                  v-if="order.is_completed_weighting && ((order.payment_cash !== order.price) && (order.payment_transferred !== order.price) && (order.payment_card !== order.price))"
                  theme="warning"
                  class="action-button"
                  title="Płatność"
                  @click.prevent="openModalPayment(order)">
                  <i
                    class="material-icons"
                    style="transform: rotate(360deg); margin-left: 0.2rem">euro_symbol</i>
                </d-button>
                <d-button
                  theme="primary"
                  class="action-button"
                  title="Edytuj"
                  @click.native="$router.push('/zamowienia/edycja/' + order.id)">
                  <i class="material-icons">edit</i>
                </d-button>
                <d-button
                  theme="danger"
                  class="action-button"
                  title="Usuń"
                  @click.native="removeOrder(order.id)">
                  <i class="material-icons">delete</i>
                </d-button>
              </div>
            </td>
          </tr>
          <tr v-if="orders.length === 0 || orders.data.length === 0">
            <td
              colspan="9"
              class="text-center">
              Brak zamówień do wyświetlenia&hellip;
            </td>
          </tr>
        </tbody>
      </table>
      <orders-transport
        :key="transportKey"
        :show-component="current_view === 'planRoute'"
        :date="startDate"
        :key-data="date_key"
        :refresh="refreshItems" />
      <orders-transport-duplicate
        :show-component="current_view === 'duplicateRoute'"
        :current-date="current_date" />

      <div
        v-if="(!loaded || !orders) && current_view === 'main'"
        class="pb-3 pt-3 text-center">
        Trwa ładowanie danych&hellip;
      </div>

      <d-alert
        v-if="loaded && load_error && current_view === 'main'"
        show
        theme="warning">
        Wczytywanie danych nie powiodło się. <a
          href="javascript:window.location.reload();"
        class="alert-link">Odśwież stronę</a> aby spróbować ponownie.
      </d-alert>
    </d-card>
    <orders-form-payment
      :key="show_payment_module_key"
      :close-modal="closeModalPayment"
      :current-order="payment_module_order"
      :refresh="refreshPayment"
      :show-modal="show_payment_module" />
    <order-file
      :key="'file-' + modal_file_key"
      :close-modal="closeModalFile"
      :show-modal="show_modal_file"
      :refresh="loadFilteredData" />
    <orders-collapse
      v-if="supplies_check && current_view === 'main'"
      :orders="orders.data"
      :supplies="supplies"
      :products="products" />
    <orders-weighing-module
      :key="'weighing-' + show_weighing_module_key"
      :close-modal="closeWeighingModule"
      :is-edit="show_weighing_module_edit"
      :refresh-list="loadFilteredData"
      :order="show_weighing_module_data"
      :show-modal="show_weighing_module"
      :date="current_date.date + ' ' + month[current_date.month - 1] + ' ' + current_date.year"
      :supplier="id_supplier" />
    <order-supplier
      :key="'supplier-' + supplier_key"
      :close-modal="closeSupplierModal"
      :show-modal="supplier_modal"
      :suppliers="suppliers"
      :data-to-send="order"
      :refresh="loadFilteredData"
      :is-edit="supplier_id" />
    <orders-bulk-payment-info
      :close-modal="closeBulkPaymentInfo"
      :show-modal="bulk_payment_modal"
      :different-payments="different_payments" />

    <d-card
      v-show="current_view === 'main'"
      class="mt-3 mb-3">
      <d-card-body
        class="pt-4 pb-3 pl-4 pr-4"
        role="tab">
        <d-row
          v-if="current_view === 'main'"
          class="d-flex ml-0 mb-3 page-filters w-100 justify-content-end align-items-center">
          <h3
            class="m-0 page-title"
            style="flex: 1;">
            Dodatkowe akcje
          </h3>

          <div class="d-flex align-items-center">
            <d-button
              theme="primary"
              title="Pobierz plik"
              class="text-nowrap"
              :disabled="export_file !== false"
              @click.prevent="exportFileDoc">
              <template v-if="export_file === false">
                Pobierz plik
                <i
                  class="material-icons"
                  style="transform: rotate(180deg); margin-left: 0.2rem;">
                  keyboard_capslock
                </i>
              </template>
              <template v-else>
                <div
                  class="spinner-border spinner-border-sm"
                  role="status" />
              </template>
            </d-button>

            <d-button
              theme="secondary"
              outline
              title="Przesyłanie ważenia"
              class="text-nowrap ml-2"
              @click.prevent="openModalFile">
              Wgraj plik
              <i
                class="material-icons"
                style="transform: rotate(360deg); margin-left: 0.2rem;">
                keyboard_capslock
              </i>
            </d-button>

            <d-button
              v-if="!button_disabled_pdf"
              theme="success"
              class="text-nowrap ml-2"
              style="min-width: 6rem;"
              :disabled="download !== false"
              @click="exportDriversFilePDF">
              Podsumowanie dla kierowców
              <i
                class="material-icons"
                style="transform: rotate(360deg); margin-left: 0.2rem;">
                download
              </i>
            </d-button>
          </div>
        </d-row>

        <hr class="my-3">
        <d-row class="d-flex ml-0 w-100 align-items-center justify-content-between">
          <span
            class="text-muted font-weight-bold text-uppercase"
            style="font-size: 0.75rem; letter-spacing: 0.5px;">
            Powiązane widoki
          </span>
          <router-link
            to="/zamowienia-usuniete"
            title="Usunięte zamówienia"
            class="btn btn-outline-primary btn-sm d-inline-flex align-items-center">
            Usunięte zamówienia
            <i
              class="material-icons ml-1"
              style="font-size: 1.1rem;">
              chevron_right
            </i>
          </router-link>
        </d-row>
      </d-card-body>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import debounce from 'lodash.debounce';
import FormUtils from '../../utils/FormUtils.js';
import HasFilters from '../../mixins/HasFilters.vue';
import HasPagination from '../../mixins/HasPagination.vue';
import HasSorting from '../../mixins/HasSorting.vue';
import ListUtils from '../../utils/ListUtils.js';
import Pagination from '../../components/common/Pagination.vue';
import CalendarUtils from '@/utils/CalendarUtils';
import PaymentUtils from '@/utils/PaymentUtils';
import OrderFormCalendar from '@/components/forms/orders/OrderFormCalendar';
import OrderSupplier from '@/views/Orders/OrdersSupplier';
import OrdersCollapse from '@/views/Orders/OrdersCollapse';
import Vue from 'vue';
import OrderFile from '@/views/Orders/OrdersFile';
import axios from 'axios';
import api from '@/api';
import OrdersWeighingModule from '@/views/Orders/OrdersWeighingModule';
import OrdersFormPayment from '../../components/forms/orders/OrdersFormPayment';
import OrdersTransport from './OrdersTransport';
import OrdersTransportDuplicate from './OrdersTransportDuplicate';
import OrdersBulkPaymentInfo from './OrdersBulkPaymentInfo.vue';

const moment = require('moment');

export default {
  name: 'orders',
  components: {
    OrdersTransport,
    OrdersTransportDuplicate,
    OrdersFormPayment,
    OrdersWeighingModule,
    OrderFile,
    OrdersCollapse,
    OrderSupplier,
    OrderFormCalendar,
    OrdersBulkPaymentInfo,
    'pagination': Pagination
  },
  mixins: [
    HasFilters,
    HasPagination,
    HasSorting
  ],
  data () {
    return {
      orders: [],
      conditions: [],
      order: [],
      ids: [],
      suppliers: [],
      loaded_suppliers: false,
      supplies: [],
      products: [],
      ids_all: false,
      loaded: false,
      load_error: false,
      remove_in_progress: false,
      show_calendar: false,
      show_modal_file: false,
      export_file: false,
      download: false,
      supplier_modal: false,
      button_disabled_pdf: false,
      show_weighing_module: false,
      current_view: 'main',
      route_downloading: false,
      payment_module_order: {},
      transportKey: 0,
      show_weighing_module_data: [],
      show_payment_module: false,
      supplies_check: false,
      show_payment_module_key: 0,
      show_weighing_module_key: 0,
      show_weighing_module_edit: '',
      week_days: ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'Nd'],
      week_day_names: ['Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota', 'Niedziela'],
      month: ['Styczeń', 'Luty', 'Marzec', 'Kwiecień', 'Maj', 'Czerwiec', 'Lipiec', 'Sierpień', 'Wrzesień', 'Październik', 'Listopad', 'Grudzień', '', ''],
      month_short: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru', '', ''],
      month_number: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '', ''],
      day_number: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '', ''],
      first_day_prev: '',
      day_prev: '',
      day: '',
      current_date_copy_date: '',
      downloading: '',
      days_count: 1,
      supplier_id: '',
      id_supplier: '',
      supplier_key: 0,
      count: 0,
      modal_file_key: 0,
      date_key: 0,
      date_context: moment(),
      bulk_payment_modal: false,
      different_payments: [],
      current_date: {
        date: 0,
        month: 0,
        year: 0,
        yearAdd: 0
      },
      isWeightValues: [
        {
          value: '',
          name: 'Wszystkie'
        },
        {
          value: 'UNWEIGHT',
          name: 'Tylko niezważone'
        },
        {
          value: 'PARTIAL',
          name: 'Tylko częściowo zważone'
        },
        {
          value: 'FULL',
          name: 'Tylko zważone'
        }
      ],
      filters: {
        search: '',
        user_id: '',
        customer_id: '',
        shop_id: '',
        supplier_id: '',
        weighting_status: '',
        delivery_date: '',
        delivery_date_from: '',
        delivery_date_to: ''
      },
      isSupplierFilterSaved: false,
      sorting: {
        column: 'id',
        direction: 'DESC'
      },
      isMergeInProgress: false
    };
  },
  watch: {
    startDate () {
      this.saveDate(this.startDate);
      this.loadFilteredData();
      this.firstDayInLastMonth();
    },
    ids_all (val) {
      if (val) {
        this.ids = this.orders.data.map((el) => el.id);
      } else {
        this.ids = [];
      }
    }
  },
  mounted () {
    this.$bus.$on('show-main-view', this.showMainView);
    this.loadSuppliers();
    if (!this.getDate) {
      this.saveDate(this.startDate);
    } else {
      this.current_date.year = Number(this.getDate.split('-')[0]);
      this.current_date.month = Number(this.getDate.split('-')[1]);
      this.current_date.date = Number(this.getDate.split('-')[2]);
    }
    this.loadFilteredData();
  },
  'current_date.month': function () {
    this.firstDayInLastMonth();
    setTimeout(() => {
      this.getFirstDay();
    }, 100);
  },
  'currentDate.yearAdd': function () {
    this.firstDayInLastMonth();
    this.checkTheMonthNumber();
    this.checkSundays();
    this.getFirstDay();
  },
  'currentDate.date': function () {
    this.checkTheMonthNumber();
    this.checkSundays();
  },
  created () {
    this.getCurrentDate();
  },
  computed: {
    allDataLoaded () {
      return this.loaded && this.loaded_suppliers;
    },
    prevMonthDays () {
      let year = this.current_date.month === 1 ? this.current_date.year - 1 : this.current_date.year;
      let month = this.current_date.month === 1 ? 12 : this.current_date.month;
      return new Date(year, month - 1, 0).getDate();
    },
    firstMonthDay () {
      let currentDay = new Date(this.first_day_prev.toString()).toLocaleDateString(undefined, { weekday: 'long' });
      let firstDay = new Date(this.current_date.year, this.current_date.month, 1).getDate();
      if (currentDay === 'poniedziałek') {
        firstDay = 0;
      }
      if (currentDay === 'wtorek') {
        firstDay = 1;
      }
      if (currentDay === 'środa') {
        firstDay = 2;
      }
      if (currentDay === 'czwartek') {
        firstDay = 3;
      }
      if (currentDay === 'piątek') {
        firstDay = 4;
      }
      if (currentDay === 'sobota') {
        firstDay = 5;
      }
      if (currentDay === 'niedziela') {
        firstDay = 6;
      }
      return firstDay;
    },
    currentMonthDays () {
      return new Date(this.current_date.year, this.current_date.month, 0).getDate();
    },
    prevMonth () {
      return new Date(this.current_date.year, this.current_date.month - 1, 0).getDate();
    },
    startDate () {
      return [this.current_date.year, this.current_date.month, this.current_date.date].map(n => (n < 10 ? '0' + n : n)).join('-');
    },
    currentDay () {
      const now = new Date();
      return (now.getDate() + ' ' + (this.month_short[now.getMonth()]) + ' - ' + (this.week_day_names[now.getDay() - 1]));
    },
    dayNames () {
      return CalendarUtils.getDayNames(this.startDate, this.days_count);
    },
    currentDayName () {
      const now = new Date(this.current_date.year, this.current_date.month - 1, this.current_date.date).toLocaleDateString(undefined, { weekday: 'long' });
      return now;
    },
    isBulkPaymentEnabled () {
      if (!this.orders || !this.orders.data || !this.orders.data.length) {
        return false;
      }

      if (!this.ids.length) {
        return false;
      }
      let ordersForPayment = this.orders.data.filter(item => item.is_completed_weighting && item.available_settlement_methods.length && Number(item.price) !== (Number(item.payment_cash) + Number(item.payment_transferred) + Number(item.payment_card)));
      if (this.ids.length) {
        ordersForPayment = ordersForPayment.filter(item => this.ids.indexOf(item.id) > -1);
      }

      return ordersForPayment.length > 0;
    },
    isOrdersMergeEnabled () {
      if (this.ids.length < 2) {
        return false;
      }

      let selectedOrders = this.orders.data.filter(item => this.ids.includes(item.id));
      if (!selectedOrders || selectedOrders.length < 2) {
        // this check is just in case, should not happen
        return false;
      }

      let firstOrder = selectedOrders[0];
      let customerId = firstOrder.customer_id;
      let shopId = firstOrder.shop_id;

      return selectedOrders.every(item => item.customer_id === customerId && item.shop_id === shopId);
    },
    ...mapGetters([
      'getDate'
    ])
  },
  methods: {
    ...mapActions([
      'saveDate'
    ]),

    isPartiallyWeighted (order) {
      let itemsCount = order.products.length;
      let itemsWeighted = order.products.filter(item => item.weighing_required && Number(item.weight) > 0).length;
      let itemsPacked = order.products.filter(item => !item.weighing_required && item.is_packed).length;

      let itemsRedyCount = itemsPacked + itemsWeighted;

      return itemsRedyCount > 0 && ((itemsPacked + itemsWeighted) < itemsCount);
    },
    exportFilePDF () {
      this.download = true;
      let filename = 'document-';
      axios({
        url: `${api}orders/export-pdf`,
        method: 'GET',
        params: {
          delivery_date: this.startDate,
          ids: this.ids
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + this.startDate + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        this.download = false;
      });
      setTimeout(() => {
        this.download = false;
      }, 2000);
    },
    exportRouteFileExcel () {
      this.route_downloading = true;
      let filename = 'route-';
      axios({
        url: `${api}orders/route-excel`,
        method: 'GET',
        params: {
          delivery_date: this.startDate
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + this.startDate + '.xlsx');
        document.body.appendChild(link);
        link.click();
        this.route_downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        this.route_downloading = false;
      });
    },
    exportDriversFilePDF () {
      this.download = true;
      let filename = 'suppliers-';
      axios({
        url: `${api}orders/suppliers-pdf`,
        method: 'GET',
        params: {
          delivery_date: this.startDate,
          ids: this.ids
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + this.startDate + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        this.download = false;
      });
      setTimeout(() => {
        this.download = false;
      }, 2000);
    },
    exportFileDoc () {
      this.export_file = true;
      let filename = 'Wazenie-';
      axios({
        url: `${api}orders/export-excel`,
        method: 'GET',
        params: {
          delivery_date: this.startDate
        },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + this.startDate + '.xlsx');
        document.body.appendChild(link);
        link.click();
        this.downloading = false;
        this.getSingleOrder();
        this.loadSuppliers();
      }).catch(error => {
        console.error(error);
        Vue.swal({
          title: 'Wystąpił błąd podczas pobierania',
          html: 'Spróbuj ponownie',
          type: 'warning',
          confirmButtonText: 'OK'
        });
        this.export_file = false;
      });
      setTimeout(() => {
        this.export_file = false;
      }, 2000);
    },
    openModalFile () {
      this.show_modal_file = true;
    },
    closeModalFile () {
      this.show_modal_file = false;
      this.modal_file_key += 1;
    },
    openModalPayment (order) {
      this.show_payment_module = true;
      this.payment_module_order = order;
    },
    closeModalPayment () {
      this.show_payment_module = false;
      this.payment_module_order = {};
    },
    openCalendar () {
      this.show_calendar = true;
    },
    openWeighingModule (id, supplier, data) {
      this.show_weighing_module = true;
      this.show_weighing_module_edit = id;
      this.show_weighing_module_data = data;
      this.id_supplier = supplier;
    },
    closeWeighingModule () {
      this.show_weighing_module = false;
      this.show_weighing_module_edit = '';
      this.show_weighing_module_key += 1;
      this.show_weighing_module_data = [];
      this.loadFilteredData();
    },
    closeCalendar () {
      this.show_calendar = false;
    },
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.$bus.$emit('view-sorting-save');
      this.loadFilteredData();
    }, 250),
    refreshPayment () {
      this.loadFilteredData();
    },
    refreshItems () {
      this.loadFilteredData();
    },
    loadFilteredData () {
      this.loaded = false;
      this.load_error = false;
      this.supplies_check = false;
      this.ids = [];
      let where = {
        weighting_status: this.filters.weighting_status,
        search: this.filters.search,
        supplier_id: this.filters.supplier_id ? this.filters.supplier_id : '',
        shop_id: this.filters.shop_id ? this.filters.shop_id : '',
        customer_id: this.filters.customer_id ? this.filters.customer_id : '',
        user_id: this.filters.user_id ? this.filters.user_id : '',
        delivery_date: this.startDate
      };

      this.isSupplierFilterSaved = !!this.filters.supplier_id;

      let order = this.sorting;

      this.$http.post('/orders/items', {
        pagination: false,
        where,
        order
      }).then(response => {
        this.orders = response.data;
        this.conditions = response.data.conditions;
        this.supplies = response.data.supplies;
        this.products = response.data.products;
        let arr = [];
        let arrNone = [];
        for (let i = 0; i < response.data.data.length; i++) {
          if (response.data.data[i].supplier_id !== 0) {
            arr.push(response.data.data[i].supplier_id);
          }
          if (response.data.data[i].supplier_id === 0) {
            arrNone.push(response.data.data[i].supplier_id);
          }
        }
        this.count = arr.length;
        this.countNone = arrNone.length;
        if (response.data.supplies[0].orders_count !== 0) {
          this.supplies_check = true;
        }
        if (response.data) {
          if (response.data.data.length) {
            this.button_disabled_pdf = false;
          } else {
            this.button_disabled_pdf = true;
          }
        }
        this.loaded = true;
      }).catch(error => {
        console.error(error);
        this.load_error = true;
        this.loaded = true;
      });
    },
    closeSupplierModal () {
      this.supplier_modal = false;
      this.supplier_key += 1;
    },
    getSingleOrder (id) {
      this.downloading = id;
      FormUtils.loadAdditionalData(this, {
        endpoint: '/orders/item/' + id,
        outputKey: 'order',
        params: {
          pagination: false
        },
        successAction: () => {
          setTimeout(() => {
            this.downloading = '';
            this.supplier_id = this.order.supplier_id;
            setTimeout(() => {
              if (this.supplier_id !== '') {
                this.supplier_modal = true;
              }
            }, 100);
          }, 200);
        }
      });
    },
    loadSuppliers () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/suppliers/items',
        loadedKey: 'loaded_suppliers',
        outputKey: 'suppliers',
        errorKey: 'load_error',
        params: {
          pagination: false,
          where: { active: 1 }
        }
      });
    },
    clearFilters () {
      this.filters = {
        search: '',
        supplier_id: '',
        weighting_status: ''
      };

      this.sorting = {
        column: 'id',
        direction: 'DESC'
      };

      this.loadFilteredData();
      this.$bus.$emit('view-filters-reset');
      this.$bus.$emit('view-sorting-reset');
    },
    dateUp () {
      if (this.current_date.date === this.currentMonthDays) {
        this.current_date.date = 1;
        this.monthUp();
      } else {
        this.current_date.date += 1;
      }
      this.ids = [];
    },
    dateDown () {
      if (this.current_date.date === 1) {
        this.current_date.date = this.prevMonthDays;
        this.monthDown();
      } else {
        this.current_date.date -= 1;
      }
      this.ids = [];
    },
    monthUp () {
      if (this.current_date.month === 12) {
        this.current_date.month = 1;
        this.current_date.year += 1;
      } else {
        this.current_date.month += 1;
      }
    },
    monthDown () {
      if (this.current_date.month === 1) {
        this.current_date.month = 12;
        this.current_date.year -= 1;
      } else {
        this.current_date.month -= 1;
      }
    },
    firstDayInLastMonth () {
      let month = this.month_number[this.current_date.month - 1];
      let year = this.current_date.year;
      this.first_day_prev = (year + '-' + month + '-01');
    },
    toggleView (newView) {
      if (newView === this.current_view) {
        this.current_view = 'main';
      } else {
        this.current_view = newView;
      }

      if (this.current_view === 'main') {
        this.transportKey += 1;
      }
    },
    showMainView () {
      if (this.current_view === 'duplicateRoute') {
        this.refreshItems();
      }

      this.toggleView('main');
    },
    getFirstDay () {
      this.day_prev = new Date(this.first_day_prev.toString()).toLocaleDateString(undefined, { weekday: 'long' });
    },
    checkTheMonthNumber () {
      if ((this.current_date.date === 1) || (this.current_date.date === 2) ||
        (this.current_date.date === 3) || (this.current_date.date === 4) ||
        (this.current_date.date === 5) || (this.current_date.date === 6) ||
      (this.current_date.date === 7) || (this.current_date.date === 9)) {
        this.current_date_copy_date = '0' + this.current_date.date;
      } else {
        this.current_date_copy_date = this.current_date.date;
      }
    },
    checkSundays () {
      this.day = new Date(this.current_date.year + '-' + this.month_number[this.current_date.month - 1] + '-' + this.current_date_copy_date).toLocaleDateString(undefined, { weekday: 'long' });
    },
    getCurrentDate () {
      let today = new Date();
      this.current_date.date = today.getDate();
      this.current_date.month = today.getMonth() + 1;
      this.current_date.year = today.getFullYear() + this.current_date.yearAdd;
    },
    validateFiltersForm () {
      this.$bus.$emit('pagination-reset');
      FormUtils.validate(this.$refs['orders-filters-form'], this.debouncedLoadFilteredData);
    },
    removeOrder (userID) {
      this.remove_in_progress = true;

      ListUtils.removeItem(this, {
        endpointBase: '/orders/delete/',
        id: userID,
        successTitle: 'Usunięto zamówienie',
        successText: 'Wybrane zamówienie zostało usunięte',
        confirmTitle: 'Czy na pewno chcesz usunąć to zamówienie?',
        confirmText: 'Tej operacji nie można cofnąć',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Usuwanie zamówienia nie powiodło się. Spróbuj ponownie.',
        successAction: () => {
          this.remove_in_progress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.remove_in_progress = false;
        }
      });
    },
    getOrderPriceClass (order) {
      let classList = 'text-nowrap';

      if (order.payment_cash === 0 && order.payment_transferred === 0 && order.payment_card === 0) {
        return classList + ' order-payments-red';
      }

      if (order.payment_cash !== 0) {
        if (order.payment_cash !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      if (order.payment_transferred !== 0) {
        if (order.payment_transferred !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      if (order.payment_card !== 0) {
        if (order.payment_card !== order.price) {
          return classList + ' order-payments-blue';
        }

        return classList + ' order-payments-green';
      }

      return classList + ' order-payments-red';
    },
    bulkPaymentSuccessAction (response) {
      if (response.different && response.different.length) {
        this.openBulkPaymentInfo(response.different);
      }
      this.download = false;
      this.refreshItems();
    },
    submitBulkPayments () {
      this.download = true;

      PaymentUtils.submitExpressPayment(this, {
        orders: JSON.parse(JSON.stringify(this.orders.data)),
        selectedOrdersIDs: this.ids,
        successAction: this.bulkPaymentSuccessAction,
        failAction: () => {
          this.download = false;
        },
        cancelAction: () => {
          this.download = false;
        }
      });
    },
    openBulkPaymentInfo (differentPayments) {
      this.different_payments = differentPayments;
      this.bulk_payment_modal = true;
    },
    closeBulkPaymentInfo () {
      this.bulk_payment_modal = false;
      this.different_payments = [];
    },
    sortBy (columnName) {
      let newDirection = 'DESC';

      if (this.sorting.column && this.sorting.column === columnName) {
        newDirection = this.sorting.direction === 'DESC' ? 'ASC' : 'DESC';
      }

      Vue.set(this, 'sorting', { column: columnName, direction: newDirection });
      this.debouncedLoadFilteredData();
    },
    getWZNumber (orderWZ) {
      const match = orderWZ.match(/WZ_(\d+)\//);
      return match ? match[1] : '-';
    },
    submitOrdersMerge () {
      this.isMergeInProgress = true;

      FormUtils.submit(this, {
        endpoint: '/orders/merge',
        formData: { orders: this.ids },
        successTitle: 'Połączono zamówienia',
        successText: 'Wybrane zamówienia zostały połączone w jedno.',
        errorTitle: 'Wystąpił błąd',
        errorText: 'Łączenie zamówień nie powiodło się. Spróbuj ponownie.',
        timer: 2000,
        successAction: () => {
          this.isMergeInProgress = false;
          this.debouncedLoadFilteredData();
        },
        failAction: () => {
          this.isMergeInProgress = false;
        }
      });
    }
  },
  beforeUnmount () {
    this.$bus.$off('show-main-view', this.showMainView);
  }
};
</script>
<style lang="scss">
  @import '../../assets/scss/order-list';

  .orangeBg{
    background-color: orange;
  }
  .partiallyWeightedBg {
    background-color: #ffdf00!important;
    color: #232333 !important;

    &.btn:hover {
      background-color: #ffc107!important;
    }
  }

  .order__date_top_text{
    flex-direction: column;
    .text{
      width: 250px;
      text-align: center;
    }
    .badge{
      align-self: center;
      font-size: 14px;
      margin-bottom: -24px;
    }
  }

  .column-sortable {
    padding-right: 20px!important;
    position: relative;

    &.is-active {
      &:after {
        opacity: 1;
      }

      &.is-up {
        &:after {
          top: calc(50% - 1px);
          transform: translateY(-50%) rotate(-180deg);
        }
      }
    }

    &:after {
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 7px solid var(--table-color);
      content: "";
      height: 0;
      opacity: 0.5;
      position: absolute;
      right: 5px;
      top: calc(50% + 2px);
      transform: translateY(-50%);
      transition:all .25s ease;
      width: 0;
    }
  }

  .sorting-trigger {
    cursor: pointer;

    &.is-disabled {
      pointer-events: none;
    }
  }
</style>
